import { COMPANY } from "./site";

const intro = (title) =>
  `This ${title} explains how ${COMPANY.name} ("we", "us", "our") approaches this area of our work. This is placeholder content prepared for a growing healthcare recruitment company and should be reviewed and tailored with appropriate professional advice before publication.`;

export const LEGAL_CONTENT = {
  "privacy-policy": {
    title: "Privacy Policy",
    updated: "Last reviewed: 2026",
    sections: [
      {
        heading: "Overview",
        body: intro("Privacy Policy") +
          " We are committed to protecting the privacy of employers, candidates and partners who interact with us.",
      },
      {
        heading: "Information We Collect",
        body: "We may collect contact details, professional information, CV content and correspondence you provide through our forms and communications, as well as limited technical information when you use our website.",
      },
      {
        heading: "How We Use Information",
        body: "We use personal data to provide recruitment services, respond to enquiries, manage partnerships, and communicate with you. We only process data where we have a lawful basis to do so.",
      },
      {
        heading: "Data Sharing",
        body: "We do not sell personal data. Where appropriate for recruitment purposes, information may be shared with relevant partners, employers or candidates with a lawful basis and appropriate care.",
      },
      {
        heading: "Your Rights",
        body: "You have rights over your personal data, including access, rectification and erasure. To exercise your rights, please contact us using the details on our Contact page.",
      },
      {
        heading: "Retention & Security",
        body: "We retain personal data only as long as necessary and apply appropriate technical and organisational measures to keep it secure.",
      },
    ],
  },
  "cookie-policy": {
    title: "Cookie Policy",
    updated: "Last reviewed: 2026",
    sections: [
      { heading: "Overview", body: intro("Cookie Policy") },
      { heading: "What Are Cookies", body: "Cookies are small text files placed on your device to help websites function and to understand how they are used." },
      { heading: "How We Use Cookies", body: "We may use essential cookies for site functionality and, where consented, analytics cookies to help us improve the website." },
      { heading: "Managing Cookies", body: "You can control cookies through your browser settings. Disabling some cookies may affect how the website works." },
    ],
  },
  "terms-of-business": {
    title: "Terms of Business",
    updated: "Last reviewed: 2026",
    sections: [
      { heading: "Overview", body: intro("Terms of Business") },
      { heading: "Scope of Services", body: "These terms set out the basis on which we provide healthcare recruitment and partnership services." },
      { heading: "Fees", body: "Fees, including any split fee arrangements, are agreed transparently and confirmed in writing before engagement." },
      { heading: "Responsibilities", body: "Each party is responsible for acting professionally, lawfully and in good faith throughout our engagement." },
    ],
  },
  "employer-terms": {
    title: "Employer Terms",
    updated: "Last reviewed: 2026",
    sections: [
      { heading: "Overview", body: intro("Employer Terms") },
      { heading: "Engaging Our Services", body: "These terms apply when employers request talent or engage our recruitment services." },
      { heading: "Placements", body: "Placement terms, fees and expectations are agreed in writing before work commences." },
    ],
  },
  "candidate-terms": {
    title: "Candidate Terms",
    updated: "Last reviewed: 2026",
    sections: [
      { heading: "Overview", body: intro("Candidate Terms") },
      { heading: "Working With Us", body: "These terms apply to healthcare professionals who submit their details or CV to us." },
      { heading: "Your Information", body: "We handle your CV and information with care and in line with our Privacy Policy and GDPR Privacy Notice." },
    ],
  },
  "recruitment-partner-terms": {
    title: "Recruitment Partner Terms",
    updated: "Last reviewed: 2026",
    sections: [
      { heading: "Overview", body: intro("Recruitment Partner Terms") },
      { heading: "Partnership Arrangements", body: "These terms apply to agencies, independent recruiters and referral partners collaborating with us." },
      { heading: "Fees & Splits", body: "Split fee and referral arrangements are agreed transparently and confirmed in writing." },
    ],
  },
  "gdpr-privacy-notice": {
    title: "GDPR Privacy Notice",
    updated: "Last reviewed: 2026",
    sections: [
      { heading: "Overview", body: intro("GDPR Privacy Notice") },
      { heading: "Lawful Basis", body: "We process personal data on lawful bases such as consent, legitimate interests and the performance of a contract." },
      { heading: "Data Subject Rights", body: "You have the right to access, correct, erase, restrict and object to processing of your personal data, and to data portability." },
      { heading: "Contact", body: "For any data protection query, please contact us using the details on our Contact page." },
    ],
  },
  "equal-opportunities-policy": {
    title: "Equal Opportunities Policy",
    updated: "Last reviewed: 2026",
    sections: [
      { heading: "Our Commitment", body: intro("Equal Opportunities Policy") + " We are committed to equal opportunities and to treating all candidates, employers and partners fairly and without discrimination." },
      { heading: "Fair Treatment", body: "We do not discriminate on the basis of any protected characteristic and promote inclusion throughout our recruitment activities." },
    ],
  },
  "complaints-procedure": {
    title: "Complaints Procedure",
    updated: "Last reviewed: 2026",
    sections: [
      { heading: "Overview", body: intro("Complaints Procedure") },
      { heading: "Raising a Concern", body: "If you have a concern, please contact us and we will acknowledge and investigate it fairly and promptly." },
      { heading: "Resolution", body: "We aim to resolve complaints transparently and to learn from feedback to improve our service." },
    ],
  },
  "accessibility-statement": {
    title: "Accessibility Statement",
    updated: "Last reviewed: 2026",
    sections: [
      { heading: "Our Commitment", body: intro("Accessibility Statement") + " We are committed to making our website accessible to as many people as possible." },
      { heading: "Standards", body: "We aim to follow recognised accessibility good practice, including sufficient colour contrast, keyboard navigation and clear structure." },
      { heading: "Feedback", body: "If you experience any difficulty accessing our website, please let us know via our Contact page so we can help." },
    ],
  },
};
